prismanoteApp.controller('myAccountPageBrandController', ['$scope', '$rootScope', '$state', '$brand',
  function ($scope, $rootScope, $state, $brand) {
    console.log('myAccountPageBrandController: ')
  }])
